import {PromotionTracker} from '@aboutyou/grpc-clients/tadarida/aysa_api/models//tracker.types';
import {Image as ImageType} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/image.types';
import {Link} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/link.types';
import {TrackingPromotionCreative} from '@aboutyou/legacy-tracking-sdk';
import {TrackPromotions} from '@aboutyou/tracking';

import {Idol} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/idol.types';
import {Outfit} from '@aboutyou/grpc-clients/tadarida/aysa_api/models/outfit.types';
import {Button, Image, Text, UnstyledLink} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {
  IdolImageSizes,
  ProductCollageIdolImage,
} from '../ProductCollageIdolImage/ProductCollageIdolImage';

const possibleImageWidths = [600, 800, 960, 1200];
const breakpoints = [
  {breakpoint: '(max-width: 767px)', columns: 2},
  {breakpoint: '(max-width: 1023px)', columns: 3},
  {columns: 4},
];

export const OutfitTile: React.FC<{
  cta: Link;
  image: ImageType;
  outfit?: Outfit; // used on categoty page
  idol?: Idol;
  promotionTracker?: PromotionTracker;
  source:
    | TrackingPromotionCreative.OutfitReco
    | TrackingPromotionCreative.OutfitSliderBrand;
  streamPosition: number;
}> = ({cta, image, promotionTracker, source, outfit, streamPosition, idol}) => {
  return (
    <TrackPromotions
      Comp="li"
      trackingKey={outfit?.id}
      promotion={
        source === TrackingPromotionCreative.OutfitReco
          ? {
              // used on categoty page
              outfit: outfit!,
              source,
            }
          : {
              source,
              promotionTracker: {
                ...promotionTracker!,
                destination: cta.linkTarget.url,
              },
            }
      }
      streamPosition={streamPosition}
    >
      <Wrapper to={cta.linkTarget.url} aria-label={undefined}>
        {idol ? (
          <ProductCollageIdolImage
            profileImage={idol.profileImage}
            profileName={idol.name}
            size={IdolImageSizes.small}
            increaseInset
          />
        ) : null}
        <StyledImage
          alt={image.description}
          breakpoints={breakpoints}
          ratio="3:4"
          src={image.url}
          data-testid={'profileTileImage'}
          loading="lazy"
          widths={possibleImageWidths}
        />
        <Button variant="secondary" aria-label={undefined}>
          <Text weight="mediumHeavy">{cta.label}</Text>
        </Button>
      </Wrapper>
    </TrackPromotions>
  );
};

const Wrapper = styled(UnstyledLink)`
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 2px;
  gap: 20px;
`;

const StyledImage = styled(Image)`
  border-radius: 4px;
`;
